<template>
    <v-container fluid class="px-0 pt-6 px-md-1">
        <div>
           

            <v-row v-if="permiso">
                <v-col lg=3 sm=6 md=4 cols=12 v-for="(item, index) in procesos" :key="index">
                    <v-card class="" @click="generarTablero(item)" style="border-left: 0.25rem solid #4e73df !important;">

                        <center>
                            <br />
                            <v-list-item-title class="text-h5 mb-1">
                                {{item.ptabnombre1}} {{item.ptabnombre2}}

                            </v-list-item-title>
                        </center>

                        <v-list-item three-line>

                            <v-list-item-content>
                                <center>
                                    <span style="font-size: 50px; color:#3364FF">
                                        {{item.Total}}
                                    </span>
                                    <v-list-item-subtitle>Reportes Pendientes</v-list-item-subtitle>
                                </center>

                            </v-list-item-content>
                            <v-list-item-avatar tile
                                                size="80"
                                                color="white">
                                <v-img :height="item.height"
                                       :src="item.url"></v-img>

                            </v-list-item-avatar>


                        </v-list-item>




                    </v-card>

                </v-col>

            </v-row>

        </div>
    </v-container>
</template>

<script>
    import moment from 'moment';
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import tablero from '@/services/tablero/tablero.service.js';
    import Inicio from '@/services/main/main.service.js';


    export default {
        data() {
            return {
                procesos: [],
                proceso: 0,
                nombre: '',
                permiso: false,
                cont:1

            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE']),
            //...mapState("Operacion", ["key"]),
            computedDate() {
                return this.date ? moment(this.date).format('Do MMM YYYY, dddd') : ''
            },
        },
        methods: {
            generarTablero(item) {

                if (this.cont==1) {
                    this.proceso = item.ptabclave;
                    this.nombre = item.ptabnombre;
                    this.$router.push({ name: `tablero`, params: { proceso: this.proceso, nombre: this.nombre } });
                }
                this.cont++;

            },
        },
        async mounted() {

            tablero.obtenerProcesosCliente(this);
            Inicio.VerificarPermisos(this, 314).then(response => {
                if (response.length > 0) {
                    this.permiso = true;
                }
            });

        }
 }
</script>
